import * as React from 'react';
import mergeRefs from 'react-merge-refs';
import isVeneerIcon from '../utils/is_veneer_icon';
import useFocusVisible from '../utils/use_focus_visible';
import styles from './use_styles';
import IconCheckmark from '../icons/icon_checkmark';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Step = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    index,
    appearance,
    ariaLabel,
    direction,
    expanded,
    interactive,
    isFirst,
    label,
    onBlur,
    onClick,
    onFocus,
    onKeyDown,
    status,
    step,
    noStep
  } = _ref;
  var [focusVisible, setFocusVisible] = React.useState(false);
  var {
    handleBlurVisible,
    handleFocusVisible,
    ref: focusVisibleRef
  } = useFocusVisible();
  var handleRef = mergeRefs([ref, focusVisibleRef]);
  var style = styles({
    appearance,
    direction,
    expanded,
    focusVisible,
    interactive,
    status
  });
  var isDisabled = status === 'disabled';
  var isComplete = status === 'complete';
  var isCurrent = status === 'current';
  var isInteractiveStep = !isDisabled && !isCurrent && interactive;
  if (!isInteractiveStep && focusVisible) {
    setFocusVisible(false);
  }
  var handleBlur = React.useCallback(event => {
    if (focusVisible) {
      setFocusVisible(false);
      handleBlurVisible(event);
    }
    onBlur === null || onBlur === void 0 || onBlur(event);
  }, [focusVisible, handleBlurVisible, onBlur]);
  var handleFocus = React.useCallback(event => {
    if (handleFocusVisible(event)) {
      setFocusVisible(true);
    }
    onFocus === null || onFocus === void 0 || onFocus(event);
  }, [handleFocusVisible, onFocus]);
  var handleOnClick = React.useCallback(event => {
    if (isInteractiveStep) {
      onClick === null || onClick === void 0 || onClick(event, index);
    }
  }, [isInteractiveStep, onClick, index]);
  var handleOnKeyDown = React.useCallback(event => {
    if (isInteractiveStep) {
      onKeyDown === null || onKeyDown === void 0 || onKeyDown(event, index);
    }
  }, [isInteractiveStep, onKeyDown, index]);
  var stepForeground = step;
  if (isVeneerIcon(step)) {
    stepForeground = /*#__PURE__*/React.cloneElement(step, {
      customStyle: {
        fill: style.step.color
      }
    });
  }
  if (typeof step === 'string') {
    var s = step;
    stepForeground = s.slice(0, 2);
  }
  return ___EmotionJSX(React.Fragment, null, !isFirst && ___EmotionJSX("div", {
    css: style.bar
  }), ___EmotionJSX("div", {
    css: style.stepContainer
  }, ___EmotionJSX("div", {
    "aria-disabled": isDisabled,
    "aria-label": ariaLabel,
    className: "step",
    css: style.step,
    onBlur: handleBlur,
    onClick: handleOnClick,
    onFocus: handleFocus,
    onKeyDown: handleOnKeyDown,
    ref: handleRef,
    role: "button",
    tabIndex: isInteractiveStep ? 0 : -1
  }, appearance === 'standard' && (isComplete && noStep ? ___EmotionJSX(IconCheckmark, {
    customStyle: {
      fill: style.step.color
    }
  }) : stepForeground)), ___EmotionJSX("div", {
    className: "label-small",
    css: style.label
  }, label)));
});
Step.displayName = 'Step';
export default Step;